import { createFileRoute, stripSearchParams } from '@tanstack/react-router';

import { ReleaseNotesPage } from '~/modules/releaseNotes';

import { i18n } from '~/utils';
import { buildRouteExport } from '~/utils/buildRouteExport';
import { getRouteHead } from '~/utils/routeUtils';

import {
  releaseNotesSearchDefaults,
  zodReleaseNotesSearchSchema,
} from './-searchParams';

const title = i18n.t(($) => $.pageTitle, { ns: 'release' });

export const Route = createFileRoute('/(main)/release-notes/')({
  component: ReleaseNotesPage,
  head: () => getRouteHead(title),
  search: {
    middlewares: [stripSearchParams(releaseNotesSearchDefaults)],
  },
  staticData: {
    AppBar: {
      title,
    },
  },
  validateSearch: zodReleaseNotesSearchSchema,
});

export const RELEASE_NOTES = buildRouteExport({ Route });
